import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ActivatedRoute,
} from '@angular/router';
@Component({
    selector: 'user-manage',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class UserView implements OnInit, OnDestroy {
  constructor(private ActivatedRoute: ActivatedRoute) {}
  public role;
  public userId;

  ngOnInit() {
    this.role = this.ActivatedRoute.snapshot.queryParamMap.get('role');
    this.ActivatedRoute.url.subscribe((url) => (this.userId = url[1].path));
  }

  public getPreviousUrl() {
    window.history.back();
  }

  ngOnDestroy() {}
}
